import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from "reactstrap";
import assetPath from "~/utils/assetPath";
import LinkComponent from "~/components/LinkComponent";

// external-global styles must be imported in your JS.
import styles from "./styles.scss";

class NavigationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.state = {
      isMenuOpen: false
    };
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  toggleMenu() {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <Navbar
        id="navigation_component"
        className="navbar-expand-sm"
        color="faded"
        light
        toggleable
      >
        <div className="navbar-brand">
          <LinkComponent className="frontpage" to="/">
            <img
              className="lazyload"
              width="40"
              height="40"
              alt="Frontpage"
              data-src={assetPath("frontpage", "png")}
            />
          </LinkComponent>
        </div>
        <NavbarToggler onClick={this.toggleMenu} />
        <Collapse isOpen={this.state.isMenuOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem className="Jigsaw">
              <LinkComponent to="/">Jigsaw Puzzle</LinkComponent>
            </NavItem>
            <NavItem>
              <LinkComponent to="https://online-solitaire.com/">Solitaire</LinkComponent>
            </NavItem>
            <NavItem>
              <LinkComponent to="/contact" rel="nofollow">Contact</LinkComponent>
            </NavItem>
            <NavItem>
              <LinkComponent to="/about" rel="nofollow">About</LinkComponent>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default withStyles(styles)(NavigationComponent);



// WEBPACK FOOTER //
// ./src/components/NavigationComponent/index.js